//
// This maps spIds to their corresponding design system.
// This is used to inject the correct styles/javascript to display the microfrontend.
//
export interface GetDesignSystemInfo {
  system: string;
  uri: string;
  mode?: string;
}

export interface GetDisplayConfig {
  spId: string;
  client?: string;
}

const SPID_TO_DESIGNSYSTEM: Record<string, GetDesignSystemInfo> = {
  SP301: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP251: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP252: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP299: { system: 'occl', uri: 'https://library.telefonica.de/1' },
  SP302: { system: 'occl', uri: 'https://library.telefonica.de/2' },
  SP303: { system: 'occl', uri: 'https://library.telefonica.de/65' },
  SP304: { system: 'occl', uri: 'https://library.telefonica.de/72' },
  SP602: { system: 'tefOne', uri: 'https://one.o9.de/main/fonic' },
  SP901: { system: 'tefOne', uri: 'https://one.o9.de/main/o2' },
  SP902: { system: 'tefOne', uri: 'https://one.o9.de/main/blau' },
  SP904: { system: 'tefOne', uri: 'https://one.o9.de/main/ayyildiz' },
  SP907: { system: 'tefOne', uri: 'https://one.o9.de/main/nettokom' },
  SP909: { system: 'tefOne', uri: 'https://one.o9.de/main/ortel' },
  SP910: { system: 'tefOne', uri: 'https://one.o9.de/main/whatsappsim' },
  SP912: { system: 'tefOne', uri: 'https://one.o9.de/main/alditalk' },
  SP913: { system: 'tefOne', uri: 'https://one.o9.de/main/ortel' },
};

export const CLIENT_TO_DESIGNSYSTEM: Record<string, GetDesignSystemInfo> = {
  Activate360: {
    system: 'tefOne',
    uri: 'https://one.o9.de/main/retail',
  },
  'Activate360 (mode=buttons:UndoAll)': {
    system: 'tefOne',
    uri: 'https://one.o9.de/main/retail',
    mode: 'buttons:undoAll',
  },
  'BM-Salesforce': {
    system: 'occl',
    uri: 'https://library.telefonica.de/salesforce',
    mode: 'buttons',
  },
  'COMS CS-UI': { system: 'occl', uri: 'https://library.telefonica.de/epos' },
  'EPOS Salesapp (mode=overview)': {
    system: 'occl',
    uri: 'https://library.telefonica.de/1',
    mode: 'overview',
  },
  'EPOS Salesapp': {
    system: 'occl',
    uri: 'https://library.telefonica.de/1',
    mode: 'overview',
  },
  'EPOS Web (mode=overview)': {
    system: 'occl',
    uri: 'https://library.telefonica.de/epos',
    mode: 'overview',
  },
  'EPOS Web': {
    system: 'occl',
    uri: 'https://library.telefonica.de/epos',
    mode: 'overview',
  },
  Marquez: {
    system: 'occl',
    uri: 'https://library.telefonica.de/1',
  },
  'MM-Salesforce': {
    system: 'occl',
    uri: 'https://library.telefonica.de/salesforce',
    mode: 'buttons',
  },
};

const getDisplayConfigForSpId = (spId: string) => {
  const value = SPID_TO_DESIGNSYSTEM[spId];
  if (!value) {
    throw new Error(`No designSystem found for spId ${spId}`);
  }

  return value;
};

const getDisplayConfigForClient = (client: string) => {
  const value = CLIENT_TO_DESIGNSYSTEM[client];
  if (!value) {
    throw new Error(`No designSystem found for client ${client}`);
  }

  return value;
};

export const getDisplayConfig = (options: GetDisplayConfig) => {
  const { client, spId } = options;
  if (client) {
    return getDisplayConfigForClient(client);
  }
  return getDisplayConfigForSpId(spId);
};
